<template>
    <div class="fill-height absolute w-full">
        <v-card
            class="d-flex flex-column default_card elevation-0 fill-height mx-2"
            :class="{ 'cursor-default': !dense }"
            id="card"
            :outlined="dense"
            rounded-xl
            :disabled="comingSoon"
            @click="dense ? (openDialog = dense) : null"
        >
            <v-card-text class="px-2 mb-auto fill-height">
                <div class="overlay" v-if="comingSoon">
                    <span class="font-weight-black title">Bientôt disponible</span>
                </div>
                <v-row no-gutters class="fill-height">
                    <v-col cols="12">
                        <v-row no-gutters>
                            <v-col
                                :class="{
                                    'z-1': comingSoon,
                                }"
                            >
                                <div class="text-medium-emphasis font-weight-bold text-h6">
                                    {{ title }}
                                </div>
                                <div
                                    class="text-subtitle-2 text-medium-emphasis"
                                    v-if="partnerName"
                                >
                                    {{ partnerName }}
                                </div>
                            </v-col>
                            <v-col
                                cols="2"
                                v-if="logo"
                                :class="{
                                    'd-flex justify-end pr-3 py-0': true,
                                    'z-1': comingSoon,
                                }"
                            >
                                <v-img height="50px" width="50px" contain :src="logo" />
                            </v-col>
                            <v-col v-if="!dense" cols="12" class="pt-5 text-medium-emphasis">
                                {{ text }}
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="pt-5 mt-auto" v-if="$slots['sub-text']">
                        <slot name="sub-text" />
                    </v-col>
                    <v-col cols="12" class="pt-5 text-red" v-if="errorMessage">
                        {{ errorMessage }}
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions v-if="!dense" class="py-0" style="width: 100%">
                <v-row no-gutters class="pb-2">
                    <v-col cols="6" class="d-flex align-center mb-0 py-0">
                        <v-btn
                            v-if="displayConfiguration"
                            class="px-4"
                            id="config"
                            size="small"
                            variant="flat"
                            dark
                            :disabled="activeReadonly || comingSoon"
                            @click="openDialog = true"
                        >
                            {{ settingBtnTitle || "Configurer" }}
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end">
                        <v-switch
                            v-if="displayActiveSwitch"
                            id="switch"
                            class="mt-0"
                            @click="onActive"
                            :readonly="activeReadonly || comingSoon"
                            hide-details
                            :model-value="activeSwitch"
                        />
                    </v-col>
                </v-row>
            </v-card-actions>
            <div>
                <oss-dialog
                    v-model="openDialog"
                    :title="title"
                    :minWidth="width"
                    @valid="valid"
                    @close="closeDialog"
                    @previous="previousDialog"
                    v-bind="dialogBind_"
                    :actions="actions"
                    :previousDisplay="!hidePrevious"
                    :previousDisabled="hidePrevious"
                    :hideValid="hideValid"
                >
                    <slot />

                    <template v-slot:after>
                        <v-menu offset-y v-if="!hideMoreVert">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    icon="$dots_vertical"
                                    v-bind="props"
                                    class="mx-1"
                                    color="secondary"
                                />
                            </template>

                            <v-list>
                                <v-list-item
                                    @click="handleDelete"
                                    v-if="displayDeleteBtn"
                                    title="Supprimer"
                                >
                                    <template v-slot:append>
                                        <v-icon icon="$oss-trash" size="small" />
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </oss-dialog>
            </div>
        </v-card>
    </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { DialogAction } from "@/services/dialogAction";

@Component({
    emits: ["close", "updateProfile", "onActive", "previous", "delete", "update:active"],
})
export class SettingCard extends Vue {
    @Prop({ default: "Titre" }) title: string;
    @Prop({ default: "Nom du partenaire" }) partnerName: string;
    @Prop({ default: "" }) text: string;
    @Prop({ default: null }) logo: any;
    @Prop({ default: null }) textKeys: any;

    @Model({ default: null, name: "active" }) active_: boolean;
    @Prop({ default: "Client" }) mode: string;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) profileId: string;
    @Prop({ default: "" }) settingBtnTitle: string;
    @Prop({ default: null }) dialogBind: {
        title: string;
        validTitle: string;
        validDisabled: boolean;
        "hide-valid": boolean;
        "previous-display": boolean;
    };
    @Prop({ default: null }) dialogOn: any;
    @Prop({ default: true }) closeOnValid: boolean;
    @Prop({ default: false }) activeReadonly: boolean;
    @Prop({ default: false }) comingSoon: boolean;
    @Prop({ default: "60%" }) width: string;
    @Prop({ default: "Description" }) description: string;
    @Prop({ default: "" }) errorMessage: string;
    @Prop({ default: false }) disableConfiguration: boolean;
    @Prop({ default: false }) dense: boolean; // Show a compact version of the UI
    @Prop({ default: false }) displayDeleteBtn: boolean; // Show deletion button
    @Prop({ default: false, type: Boolean, required: true }) hidePrevious!: boolean;
    @Prop({ default: false }) hideMoreVert: boolean;
    @Prop({ default: false }) hideValid: boolean;
    @Prop({ default: null }) actions: DialogAction;

    openDialog: boolean = false;

    get activeSwitch() {
        console.log("this.active_", this.active_);
        return this.active_;
    }

    get dialogBind_() {
        if (this.dialogBind) {
            return this.dialogBind;
        }
        return {
            title: this.title,
        };
    }

    set activeSwitch(value: boolean) {
        this.$emit("update:active", value);
    }

    get displayConfiguration() {
        if (this.disableConfiguration) {
            return false;
        }
        return this.$slots?.default;
    }

    get displayActiveSwitch() {
        return typeof this.active_ === "boolean";
    }

    closeDialog() {
        this.openDialog = false;
        this.$emit("close");
    }

    valid() {
        this.activeSwitch = true;
        this.$emit("updateProfile");
        if (this.closeOnValid) {
            this.closeDialog();
        }
    }

    onActive() {
        this.activeSwitch = !this.activeSwitch;
        if (!this.activeSwitch && this.displayConfiguration) {
            this.openDialog = true;
        } else {
            this.$emit("updateProfile");
        }
        this.$emit("onActive", this.activeSwitch);
    }

    previousDialog() {
        this.$emit("previous");
    }

    handleDelete() {
        this.$emit("delete", () => (this.openDialog = false));
    }
}

export default toNative(SettingCard);
</script>
<style>
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8); /* fond semi-transparent */
    color: rgb(0, 0, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    backdrop-filter: blur(5px); /* effet de flou */
    border-radius: 10px;
}
</style>
<style scoped>
.cursor-default {
    cursor: default;
}
</style>
